import {IFeedbackFileName} from '../store/types';
import {IFileUpploaderSession} from '../types';
import {
    HP_HOST_URL,
    HP_SESSION_URL_PART,
    HP_FILE_URL_PART
} from '../constants';
import { fetchHandler } from '../../../../../util/fetchHandler';

export const getFeedbackSession = () => {
    return fetchHandler(`${HP_HOST_URL}${HP_SESSION_URL_PART}`, {}, true)
        .then((responseData: any) => responseData.id);
};

export const fileUploader = (file: File, sessionId: IFileUpploaderSession): Promise<Response> => {
    const data = new FormData();
    data.append('file', file);
    return fetchHandler(`${HP_HOST_URL}${HP_FILE_URL_PART}/${sessionId}`, {
        headers: {
            'file-size': file.size,
        } as any,
        method: 'POST',
        body: data,
    }, true);
};

export const fileRemover = (name: IFeedbackFileName, sessionId: IFileUpploaderSession): Promise<any> => {
    return fetchHandler(`${HP_HOST_URL}${HP_FILE_URL_PART}/${sessionId}`, {
        headers: {
            'Content-type': 'application/json',
        },
        method: 'DELETE',
        body: JSON.stringify({name}),
    }, true);
};

export const generateUniqFileInput = (): Promise<FileList> => {
    return new Promise((res, rej) => {
        const input = <HTMLInputElement>document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('multiple', 'true');
        const onInputChange = () => {
            res(input.files);
            input.removeEventListener('change', onInputChange);
        };
        input.addEventListener('change', onInputChange);
        input.click();
    });
};
